<template>
    <h1>Competências Técnicas</h1>
    
    <!-- <hr class="my-16"> -->
    <CompetencyManagementTable 
        :competency-label="competencyLabel"
        competency-type="technical"
        :fetch-method="(filters) => TechnicalCompetencies.all(filters)"
    />
</template>

<script setup>
import CompetencyManagementTable from "@/components/assessments/competencies/CompetencyManagementTable.vue";
import TechnicalCompetencies from "@/api/assessments/competencies/TechnicalCompetencies.js";

const competencyLabel = "Competência Técnica"

</script>
